import { useEffect, useState } from "react";
import Loading from "../loading";
import HeaderSection from "./headersection";
import ItemAyat from "../shared/itemayat";
import { Utils } from "../../utils";

function RightSection({ detailSurah, toggleLeftSection, loadingDetail }) {
  const [onBookmark, setOnBookmark] = useState({});

  function setBookmark(value) {
    const bookmark = Utils.getBookmark();

    if (bookmark && bookmark["id"] === value.id) {
      setOnBookmark({});
      return Utils.removeBookmark();
    }
    Utils.setBookmark({...value, namaSurah: detailSurah.nama_latin});
    setOnBookmark({...value, namaSurah: detailSurah.nama_latin});
  }
  function isNotEmpty() {
    return Object.keys(detailSurah).length > 0;
  }

  useEffect(() => {
    const bookmark = Utils.getBookmark();
    if (bookmark) setOnBookmark(bookmark);
  }, []);

  return (
    <div className="bg-white w-full flex flex-col">
      {loadingDetail ? <Loading /> : <></>}
      {isNotEmpty() ? (
        <>
          <HeaderSection
            namaSurah={detailSurah.nama_latin}
            toggleLeftSection={toggleLeftSection} // Pass fungsi toggle ke HeaderSection
          />
          {/* List Ayat */}
          <div className="w-full h-full overflow-y-auto scrollbar-hide">
            {detailSurah.ayat.map((data, index) => (
              <ItemAyat
                key={index}
                data={data}
                setBookmark={setBookmark}
                onBookmark={onBookmark}
                showIconBookmark={true}
              />
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
}

export default RightSection;
